module.exports = __webpack_public_path__ + "71bbd3085fd057f83abc30a627d5c8ea.mp4";